import React, { useEffect, useState } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { fetchwebdevelopmentservice, base_api } from './Axios/Axios';
import {Helmet} from "react-helmet";
import './Webdevelopement.css';


function Webdevelopement() {

    useEffect(() => {
        Aos.init({ duration: 2000 })
    }, []);
    
    
return (
<div className="serviceaboutsection">
  <Helmet>
    <title>Web Development Service | Phoenix Marketing</title>
    <meta name="description" content="The top professional and creative web design and development company in Madurai. We provide a wide range of online services to build SEO-friendly websites." />
    <meta name="keywords" content="Website development company in Madurai, Madurai website designer, Madurai leading website development company, Website services company in Madurai, Website builder Madurai, Web design services in Madurai, Top web design company in Madurai, Website creator in Madurai, Website creating company in Madurai" />
    <link rel="canonical" href="https://phoenixmarketing.in/web-development-service/" />
  </Helmet>
    <div className="aboutcontent">
      <div  className="aboutsection-image-all-service">
        <img src="/Imagefile/Web Development.png" className="aboutsection-image" />
      </div>
      <div  className="service-text-center">
        <h2>Websites that look good and work even better.!</h2>
        <div className="service-underline"></div>
        <p>We build websites that are clean, modern, and user-friendly designed
          to convert visitors into customers.
        </p>
        <ul class="service-list">
          <li>Custom Website Design</li>
          <li>Responsive Development</li>
          <li>E-commerce Websites</li>
          <li>Landing Pages</li>
          <li>Website Revamp &amp; Maintenance</li>
        </ul>
      </div>
    </div>
</div>
  );
} 


export default Webdevelopement

